/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from 'react'
import missing from 'images/logo/white-on-black-wide.png'
import s from './ReadyToVisit.module.css'
import image1 from './ready1.png'
import image2 from './ready2.png'

export function ReadyToVisit({ agentAvatar = missing, agentName = '', onRequestTour }) {
  return (
    <div className={s.root}>
      <div className={s.imageWrapper1}>
        <img alt="key" src={image1} className={s.image} />
      </div>
      <div className={s.imageWrapper2}>
        <img alt="lock" src={image2} className={s.image} />
      </div>

      <div className={s.content}>
        <div className={s.title}>Ready to visit your new home?</div>
        <div className={s.text}>
          Discover and vote our listings specially selected for you. Our Agent is happy to show you the best apartments
          for you!
        </div>
      </div>

      {onRequestTour && (
        <button className={s.requestTour} type="button" onClick={onRequestTour}>
          <div className={s.avatar}>
            <img src={agentAvatar} alt={agentName} className={s.avatarImage} />
          </div>
          Request Tour
        </button>
      )}
    </div>
  )
}
